import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { newInvestmentOpportunity, updateInvestmentOpportunity } from 'services/investmentOpportunity.routes';
import * as yup from "yup";
import Fields from './Fields';
import imageCompression from 'browser-image-compression';
import moment from 'jalali-moment';

const schema = yup.object().shape({
    name: yup.string().required(),
    company_id: yup.string().required(),
    description: yup.string(),
    monthly_roi: yup.string().required(),
    yearly_roi: yup.string().required(),
    is_active: yup.string().required(),
    locked: yup.string(),
    profit_period: yup.string().required(),
    investment_started_at: yup.string(),
    logo: yup.mixed(),
    is_open: yup.string().required(),
    type: yup.string().required(),
});

export default function NewInvestmentOpportunity() {
    const [loading, setLoading] = useState(false);
    const [information, setInformation] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const method = searchParams.get("method");
    const { state } = useLocation();

    useEffect(() => {
        if (state) {
            setInformation({
                name: state.name,
                company_id: state.company_id,
                description: state.description || "",
                monthly_roi: state.monthly_roi,
                yearly_roi: state.yearly_roi,
                is_active: +state.is_active,
                locked: +state.locked,
                is_open: +state.is_open,
                type: state.type,
                profit_period: state.profit_period,
                investment_started_at: state.investment_started_at ? moment(state.investment_started_at, 'YYYY-M-D hh:mm:ss').format('jYYYY/jM/jD') : null
            });
        }
    }, [state]);

    const handleResponse = useCallback((isOk, data, successMessage) => {
        setLoading(false);
        if (!isOk) {
            toast.error(data.message);
        } else {
            toast.success(successMessage);
            navigate(`/investmentOpportunity`, { state: data });
        }
    }, [navigate]);

    const submitInvestmentOpportunityChanges = useCallback(async () => {
        if (state?.id) {
            const formdata = await handleFormData(information);
            setLoading(true);
            updateInvestmentOpportunity(state.id, formdata, (isOk, data) => {
                handleResponse(isOk, data, "فرصت سرمایه گذاری ویرایش شد!");
            });
        }
    }, [state, information, handleResponse]);

    const submitInvestmentOpportunity = useCallback(() => {
        schema.validate(information)
            .then(async (res) => {
                if (res) {
                    const formdata = await handleFormData(information);
                    setLoading(true);
                    newInvestmentOpportunity(formdata, (isOk, data) => {
                        handleResponse(isOk, data, "فرصت سرمایه گذاری جدید ایجاد شد!");
                    });
                }
            }).catch(err => {
                setLoading(false);
                toast.error(err.errors[0]);
            });
    }, [information, handleResponse]);
    const handleFormData = async (info) => {
        let formdata = new FormData();
        const { logo, investment_started_at, ...restInformation } = info;
        for (let item in restInformation) {
            if (restInformation[item]) formdata.append(item, restInformation[item]);
        }
        if (logo && logo.length > 0 && logo[0] instanceof File) {
            const compressedImage = await imageCompression(logo[0], { maxSizeMB: 2 });
            formdata.append("logo", compressedImage);
        }
        if (investment_started_at)
            formdata.append("investment_started_at", moment(investment_started_at, 'jYYYY/jM/jD').format('YYYY-M-D'))
        return formdata;
    };
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />
            <Fields
                method={method}
                information={information}
                handleUpdate={submitInvestmentOpportunityChanges}
                setInformation={setInformation}
                submit={submitInvestmentOpportunity}
            />
        </DashboardLayout>
    );
}
